module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0065.jpg?v=48f5f177";